// customFieldPresets.js — perguntas prontas por nicho. O id é o de `public.theme`, e tema fora daqui usa o padrão.
// Sugestão só abre a criação preenchida: o dono revê e cria, e conta no limite como qualquer outra.
import { CustomFieldTarget, CustomFieldType } from '../../catalogs/pageCatalog.generated';

const T = CustomFieldType;
const PERSON = CustomFieldTarget.Person;

const opcoes = (...labels) => ({ options: labels.map((label) => ({ id: '', label })) });

const COMO_CONHECEU = { key: 'como-conheceu', label: 'Como você conheceu a gente?', fieldType: T.SingleChoice, target: PERSON, rules: opcoes('Indicação', 'Instagram', 'Google', 'Outro') };
const OBSERVACAO = { key: 'observacao', label: 'Algo que devemos saber antes do atendimento?', fieldType: T.TextLong, rules: {} };
const CONVENIO = { key: 'convenio', label: 'Qual seu convênio?', fieldType: T.SingleChoice, target: PERSON, rules: opcoes('Particular', 'Unimed', 'Bradesco Saúde', 'Outro') };
const ALERGIA = { key: 'alergia', label: 'Tem alergia a algum medicamento ou produto?', fieldType: T.TextShort, target: PERSON, rules: {} };
const OBJETIVO = { key: 'objetivo', label: 'Qual seu objetivo?', fieldType: T.TextLong, rules: {} };

const PRESETS = {
  default: [COMO_CONHECEU, OBSERVACAO],
  barbershop: [COMO_CONHECEU, { key: 'estilo', label: 'Tem referência do corte que você quer?', fieldType: T.TextShort, rules: {} }],
  company: [{ key: 'empresa', label: 'Nome da sua empresa', fieldType: T.TextShort, target: PERSON, rules: {} }, OBSERVACAO],
  'tattoo-studio': [
    { key: 'descricao', label: 'Descreva a tatuagem que você quer', fieldType: T.TextLong, rules: {} },
    { key: 'regiao', label: 'Em qual parte do corpo?', fieldType: T.TextShort, rules: {} },
    { key: 'primeira', label: 'É sua primeira tatuagem?', fieldType: T.YesNo, rules: {} },
  ],
  'beauty-salon': [COMO_CONHECEU, ALERGIA],
  psychology: [
    { key: 'primeira-sessao', label: 'Já fez terapia antes?', fieldType: T.YesNo, target: PERSON, rules: {} },
    { key: 'modalidade', label: 'Prefere atendimento presencial ou online?', fieldType: T.SingleChoice, rules: opcoes('Presencial', 'Online') },
  ],
  aesthetics: [ALERGIA, { key: 'procedimento', label: 'Já fez esse procedimento antes?', fieldType: T.YesNo, rules: {} }],
  massage: [{ key: 'dor', label: 'Sente dor em alguma região?', fieldType: T.TextShort, rules: {} }, { key: 'gestante', label: 'Está gestante?', fieldType: T.YesNo, rules: {} }],
  dental: [CONVENIO, ALERGIA],
  medical: [CONVENIO, ALERGIA, { key: 'medicamentos', label: 'Usa algum medicamento de forma contínua?', fieldType: T.TextLong, target: PERSON, rules: {} }],
  therapy: [OBJETIVO, { key: 'primeira-sessao', label: 'É sua primeira sessão?', fieldType: T.YesNo, rules: {} }],
  teacher: [
    { key: 'nivel', label: 'Qual seu nível?', fieldType: T.SingleChoice, target: PERSON, rules: opcoes('Iniciante', 'Intermediário', 'Avançado') },
    OBJETIVO,
  ],
  'personal-trainer': [OBJETIVO, { key: 'restricao', label: 'Tem alguma restrição ou lesão?', fieldType: T.TextShort, target: PERSON, rules: {} }],
};

export function presetsForTheme(themeId) {
  return PRESETS[themeId] || PRESETS.default;
}
